/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PoolOverflowBehavior = {
    Deny: 'Deny',
    OrgPays: 'OrgPays',
    ParkerPays: 'ParkerPays'
} as const;
export type PoolOverflowBehavior = typeof PoolOverflowBehavior[keyof typeof PoolOverflowBehavior];

